"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * return json string from json-like string
 */
function jsonize(str) {
    try {
        JSON.parse(str);
        return str;
    }
    catch (e) {
        return str
            .replace(/([\$\w]+)\s*:/g, // wrap keys without double quote
        function (_, $1) {
            return '"' + $1 + '":';
        })
            .replace(/'([^']+)'/g, // replacing single quote to double quote
        function (_, $1) {
            return '"' + $1 + '"';
        });
    }
}
exports.jsonize = jsonize;
;
/**
 * Returns string to an object by using JSON.parse()
 */
function getJSON(input) {
    if (typeof input === 'string') {
        var re = /^[\+\-]?[0-9\.]+,[ ]*\ ?[\+\-]?[0-9\.]+$/; // lat,lng
        if (input.match(re)) {
            input = '[' + input + ']';
        }
        return JSON.parse(jsonize(input));
    }
    else {
        return input;
    }
}
exports.getJSON = getJSON;
;
/* tslint:enable */
/**
 * Returns camel-cased from string 'Foo Bar' to 'fooBar'
 */
function toCamelCase(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
        return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
    }).replace(/\s+/g, '');
}
exports.toCamelCase = toCamelCase;
function isMapsApiLoaded() {
    return typeof google === 'object' && typeof google.maps === 'object';
}
exports.isMapsApiLoaded = isMapsApiLoaded;
//# sourceMappingURL=util.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngui/map/dist/services/util.js
// module id = 155
// module chunks = 4